import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AdminConfigurationService } from '../services/admin/admin-configuration.service';
import { Configuration } from '../common/model/dto/configuration';

const ADMIN_CONFIGURATION_QUERY_KEY = ['admin-configuration'];

export function useAdminConfiguration() {
  const qc = useQueryClient();

  const latestConfiguration = useQuery({
    queryKey: ADMIN_CONFIGURATION_QUERY_KEY,
    queryFn: () => AdminConfigurationService.getLatestConfiguration(),
  });

  const updateConfiguration = useMutation({
    mutationFn: (configuration: Configuration) =>
      AdminConfigurationService.updateConfiguration(configuration),
    onSuccess: (configuration) =>
      qc.setQueryData(ADMIN_CONFIGURATION_QUERY_KEY, configuration),
  });

  const clearConfigurationCache = useMutation({
    mutationFn: () => AdminConfigurationService.clearConfigurationCache(),
  });

  const isLoading =
    latestConfiguration.isFetching ||
    updateConfiguration.isPending ||
    clearConfigurationCache.isPending;
  const error =
    latestConfiguration.error ??
    updateConfiguration.error ??
    clearConfigurationCache.error;

  return {
    latestConfiguration: latestConfiguration.data,
    isLoading,
    error,
    updateConfiguration,
    clearConfigurationCache,
  };
}
